import React from "react";
import "../styles/contacto.css";

export default function Contacto() {
  const email = "vickymonteroarbesu@gmail.com"; 
  const instagram = "https://instagram.com/vickytarotangelico"; 
  const tiktok = "https://tiktok.com/@santeria.casa.de";
  const telefono = "5491123456789"; 
  const whatsappMsg = "Hola Vicky, quiero hacer una consulta sobre Tarot Angélico";

  return (
    <section className="contacto-section">
      <div className="contacto-contenedor">
        <div className="contacto-info">
          <h2>Contacto</h2>
          <p className="contacto-subtitulo">
            Estoy para acompañarte. Escribime y coordinamos tu consulta.
          </p>

          <div className="contacto-cards">
            <a
              className="contacto-card"
              href={`https://wa.me/${telefono}?text=${encodeURIComponent(whatsappMsg)}`}
              target="_blank"
              rel="noreferrer"
            >
              <span>🟢</span>
              <div>
                <h3>WhatsApp</h3>
                <p>+54 9 11 5626-9545</p>
              </div>
            </a>

            <a className="contacto-card" href={`mailto:${email}`}>
              <span>✉️</span>
              <div>
                <h3>Email</h3>
                <p>{email}</p>
              </div>
            </a>

            <a className="contacto-card" href={instagram} target="_blank" rel="noreferrer">
              <span>📷</span>
              <div>
                <h3>Instagram</h3>
                <p>@vickytarotangelico</p>
              </div>
            </a>

            <a className="contacto-card" href={tiktok} target="_blank" rel="noreferrer">
              <span>🎵</span>
              <div>
                <h3>TikTok</h3>
                <p>@santeria.casa.de</p>
              </div>
            </a>
          </div>

          <a
            className="btn-consultame-ahora"
            href={`https://wa.me/${telefono}?text=${encodeURIComponent(whatsappMsg)}`}
            target="_blank"
            rel="noreferrer"
          >
            ✨ Consultame Ahora ✨
          </a>
        </div>

        <div className="contacto-mapa">
          <h3>Ubicación</h3>

          <a
            href="https://maps.google.com/?q=Grecia+4474,+Nuñez,+Buenos+Aires,+Argentina"
            target="_blank"
            rel="noreferrer"
            className="direccion-link"
          >
            Grecia 4474, Núñez, CABA
          </a>

          <iframe
            title="Ubicación"
            src="https://www.google.com/maps?q=Grecia+4474,+Nuñez,+Buenos+Aires,+Argentina&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>
  );
}